import styled, { css, keyframes } from "styled-components";
import { mobile as s } from "../../../../../ui/_themes/constants";
import * as h from "../../../../../ui/_themes/helpers";

const traverse = keyframes`
  0% {
    transform: translateX(100vw);
  }
  100% {
    transform: translateX(-100%);
  }
`;

const animation = props => css`
  ${!props.animationStopped &&
    css`
      animation: ${traverse} 15s linear infinite forwards;
    `};
`;

export const TickerText: any = styled.div`
  pointer-events: all;
  color: ${h.getColor("tickerDisplay")};
  font-weight: 400;
  font-size: ${s.fontSize.xxs};
  white-space: nowrap;
  display: inline-block;
  ${animation};

  @media (orientation: landscape) {
    font-size: ${s.fontSize.xs};
  }
`;
